module.exports = __webpack_public_path__ + "assets/img/delta_logo_rgb_2026.3d40e07a.png";